import React from "react";

// reactstrap components
import {
  Button,
  Card,
  CardBody,
  CardFooter,
  CardTitle,
  Container,
  Row,
  Col,
} from "reactstrap";

// core components
import NavbarTop from "../components/NavbarTop";
import Footer from "./Footer";

function Aboutus() {
  let VoluteerDetails = [
    {
      name: "Jainam singhai",
      institute: "Acropolis institute of technology and research",
      linkedin: "https://www.linkedin.com/in/jainam-singhai-418b8220a",
      profilePicture:
        "https://drive.google.com/uc?export=view&id=1cO-McQ0YvDlDy2lKw7nUJnk4Hb5bLZg9",
    },
    {
      name: "Aman Jain",
      institute: "Acropolis institute of technology and research",
      linkedin: "https://www.linkedin.com/in/aman-jain-7a1ba817a",
      profilePicture:
        "https://drive.google.com/uc?export=view&id=1xV_nxof25RMLYWwhdgoD379iG33gp1FW",
    },
    {
      name: "Prajwal Joshi",
      institute: "Acropolis institute of technology and research",
      linkedin: "http://linkedin.com/in/prajwal-joshi-300ab320a",
      profilePicture:
        "https://drive.google.com/uc?export=view&id=1eyzPalWWG5LXbBqojTOllD4Kv5MOiRka",
    },
    {
      name: "Mahendra Shaktawat",
      institute: "Acropolis institute of technology and research",
      linkedin: "https://www.linkedin.com/in/mahendra-shaktawat-8aa327211",
      profilePicture:
        "https://drive.google.com/uc?export=view&id=1DyRTLpqxZOlNfLBQu65N1soZ4mgawtDX",
    },
    {
      name: "Ishika Shroff",
      institute: "Acropolis institute of technology and research",
      linkedin: "http://linkedin.com/in/ishika-shroff-24b6b21b9",
      profilePicture:
        "https://drive.google.com/uc?export=view&id=1VMrR1PUVmSKScc7XpMYE_H6uPcAhUiVY",
    },
    {
      name: "Jaydeep Singh Chouhan",
      institute: "Acropolis institute of technology and research",
      linkedin: "https://www.linkedin.com/in/jaydeep-chouhan-348b901b5",
      profilePicture:
        "https://drive.google.com/uc?export=view&id=19Xwtt1IGIfJ19y9dzQlM7SnEmdrOd4RU",
    },
    {
      name: "Jhalak lohani",
      institute: "Comfeeders Aisect College of professional studies",
      linkedin: "https://www.linkedin.com/in/jhalak-lohani-5526b8211",
      profilePicture:
        "https://drive.google.com/uc?export=view&id=19G2SzNR1wby6v8aLcMztWkTJRACgO-uF",
    },
    {
      name: "Chanchal Talreja ",
      institute: "Aisect college ",
      linkedin: "https://www.linkedin.com/in/chanchal-talreja-988a181a9",
      profilePicture:
        "https://drive.google.com/uc?export=view&id=18Whkjzn4ItWwrjUgj-HuO0UzpYOzI3zs",
    },
    {
      name: "Ritisha Panjwani",
      institute: "Acropolis Institute of Technology and Research",
      linkedin: "https://www.linkedin.com/in/ritisha-panjwani-932329211",
      profilePicture:
        "https://drive.google.com/uc?export=view&id=13A8A7OCYL-BgphPDWMroKHfhs4WvGVE0",
    },
    {
      name: "Anushika Sharma",
      institute: "Acropolis Institute of Technology and Research",
      linkedin: "https://www.linkedin.com/in/anushika-sharma-8926871b3",
      profilePicture:
        "https://drive.google.com/uc?export=view&id=1qBFoT2_WwE639VB0shSIGsGcPsb9dAlL",
    },
    {
      name: "Kunal Pratap Singh Pawar",
      institute: "Acropolis Institute of Technology and Research",
      linkedin:
        "https://www.linkedin.com/in/kunal-pratap-singh-pawar-a8635b20a",
      profilePicture:
        "https://drive.google.com/uc?export=view&id=1JpBmjJwE0Y_DI4w0lel_WVFRQCB5k40v",
    },
    {
      name: "Muskan Soni",
      institute: "Acropolis Institute of Technology and Research",
      linkedin: "https://www.linkedin.com/in/muskan-soni-65aa77207",
      profilePicture:
        "https://drive.google.com/uc?export=view&id=1bcQm-pCVJ7BLoaFWTHKWBOYfOQPOEc-u",
    },
    {
      name: "Neha Patel",
      institute: "Acropolis Institute of Technology and Research",
      linkedin: "https://www.linkedin.com/in/neha-patel-b73a70209",
      profilePicture:
        "https://drive.google.com/uc?export=view&id=18I8NwtM9vR-C3x_vu9rMyPWcMIAu9wbm",
    },
    {
      name: "Priyanshi toshniwal",
      institute: "Acropolis Institute of Technology and Research",
      linkedin: "https://www.linkedin.com/in/priyanshi-toshniwal-928916203",
      profilePicture:
        "https://drive.google.com/uc?export=view&id=1uZ0_TZz5Hv98vbrD2pf-NaCPxksJT31Y",
    },
    {
      name: "Rakshika Patidar",
      institute: "Acropolis Institute of Technology and Research",
      linkedin: "https://www.linkedin.com/in/rakshika-patidar-21b970170",
      profilePicture:
        "https://drive.google.com/uc?export=view&id=10KqEF69PX0CZti9PYewpJ0lAkl3iXO5V",
    },
    {
      name: "Bhagyesh Agrawal",
      institute: "Prestige Institute of Management and Research (UG)",
      linkedin: "http://linkedin.com/in/bhagyesh-agrawal-30a7a9211",
      profilePicture:
        "https://drive.google.com/uc?export=view&id=1Q5VQICLbjKWLlH4HM3-9NA_vDXE5dQtz",
    },
    {
      name: "Ritisha Panjwani",
      institute: "Prestige Institute of Management and Research (UG)",
      linkedin: "https://www.linkedin.com/in/ritisha-panjwani-932329211",
      profilePicture:
        "https://drive.google.com/uc?export=view&id=1Sr3orwzCUcI9N-hyju_XM4wPpa54kD-3",
    },
    {
      name: "Gaurav shere",
      institute: "Prestige Institute of Management and Research (UG)",
      linkedin: "https://www.linkedin.com/in/gaurav-s-602466205",
      profilePicture:
        "https://drive.google.com/uc?export=view&id=1srHT8pK0JYrE6U6he1EgoCryCq9mQP0X",
    },
  ];

  let techTeam = [
    {
      name: "Bhavesh Raina",
      profilePicture:
        "https://drive.google.com/uc?export=view&id=1XwZeal4dyoa42gTO04vQ2GjizaN6gRAG",
      linkedin: "https://www.linkedin.com/in/bhavesh-raina-07ba3688",
    },
    {
      name: "Devesh Lashkari",
      profilePicture:
        "https://drive.google.com/uc?export=view&id=1g2dL3hWRDXjogA94xB5dXdlzmdgOqb-s",
      linkedin: "https://www.linkedin.com/in/deveshlashkari/",
    },
    {
      name: "Aman Garg",
      profilePicture:
        "https://drive.google.com/uc?export=view&id=1XdRIhj6yeheEDt9E2B4VzqbJK_BP3Ic0",
      linkedin: "https://www.linkedin.com/in/aman-garg-4ba0a638",
    },
    {
      name: "Karan Purswani",
      profilePicture:
        "https://drive.google.com/uc?export=view&id=1XpMoU3d5dwLf6Iu1YrzVwrXSoWWLGU64",
      linkedin: "https://www.linkedin.com/in/karan-purswani-5b3a9a171",
    },
    {
      name: "Amisha Singh",
      profilePicture:
        "https://drive.google.com/uc?export=view&id=1Ygu6cmCZRWyv5hQegXtvX4vJPRTB0yuP",
      linkedin: "http://www.linkedin.com/in/amisha-singh-2a5a77155",
    },
  ];

  document.documentElement.classList.remove("nav-open");
  React.useEffect(() => {
    document.body.classList.add("about-us");
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
    return function cleanup() {
      document.body.classList.remove("about-us");
    };
  });
  return (
    <>
      <NavbarTop />
      <div
        className="page-header"
        style={{
          backgroundImage:
            "url(" +
            require("assets/img/sections/gerrit-vermeulen.jpg").default +
            ")",
          minHeight: "40vh",
        }}
      >
        <div className="" />
        <div className="content-center">
          <Container>
            <h1>
              Hello, <br />
              We are Svastha
            </h1>
          </Container>
        </div>
      </div>

      <div className="main">
        <div className="section">
          <Container>
            <ul>
              <li>
                <h4 style={{textAlign: "justify", textJustify: "inter-word"}}>
                  Svastha is a community betterment initiative – of the people,
                  by the people and for the people, towards a Covid-19 free
                  Indore, jointly powered & coordinated by Shubhankar Social
                  Foundation and ProtonsHub Technologies, Indore.
                </h4>
              </li>
              <li>
                <h4 style={{textAlign: "justify", textJustify: "inter-word"}}>
                  Svastha the online platform is an honest attempt to be a
                  one-stop reference, both in Web & Application mode, for all
                  critical queries related to dealing in an emergency of a COVID
                  – 19 patient, battling for life.
                </h4>
              </li>
              <li>
                <h4 style={{textAlign: "justify", textJustify: "inter-word"}}>
                  Citizens can call our helpline – 0731- 4854004 – between 8.30
                  hrs to 22.30 hrs, including Sundays and Holidays for any
                  information required related to COVID – 19.
                </h4>
              </li>
            </ul>
            <h3 className="title-uppercase" style={{textAlign: "justify", textJustify: "inter-word"}}>
              {" "}
              We wish you all the best for a Corona-free Indore & India.
              Together we can, overcome this challenge.
              <i className="fa fa-heart heart mr-3 ml-1" />
            </h3>

            <h1 className="text-center creators">Team</h1>
            <hr />
            {/* Founder Section Starts */}
            <h2 className="text-center creators">Founders</h2>
            <Row>
              <Col md="4">
                <Card className="card-profile card-plain">
                  <CardBody>
                    <div className="card-avatar">
                      <a href="#pablo" onClick={(e) => e.preventDefault()}>
                        <img
                          alt="..."
                          src={
                            "https://svastha.in/wp-content/uploads/2021/05/WhatsApp-Image-2021-05-07-at-14.46.03.jpeg"
                          }
                        />
                        <CardTitle tag="h4">Atul N Bharat</CardTitle>
                      </a>
                    </div>
                    <p className="card-description text-center">
                      Atul N Bharat
                    </p>
                  </CardBody>
                  <CardFooter className="text-center">
                    <Button className="btn-just-icon mr-1" color="linkedin">
                      <i className="fa fa-linkedin" />
                    </Button>
                  </CardFooter>
                </Card>
              </Col>
              <Col md="4">
                <Card className="card-profile card-plain">
                  <CardBody>
                    <div className="card-avatar">
                      <a href="#pablo" onClick={(e) => e.preventDefault()}>
                        <img
                          alt="..."
                          src={
                            "https://svastha.in/wp-content/uploads/2021/05/1-–-1.png"
                          }
                        />
                        <CardTitle tag="h4">Pratap Nair</CardTitle>
                      </a>
                    </div>
                    <p className="card-description text-center">Pratap Nair</p>
                  </CardBody>
                  <CardFooter className="text-center">
                    <Button
                      className="btn-just-icon mr-1"
                      color="linkedin"
                      href="#pablo"
                      onClick={(e) => e.preventDefault()}
                    >
                      <i className="fa fa-linkedin" />
                    </Button>
                  </CardFooter>
                </Card>
              </Col>
              <Col md="4">
                <Card className="card-profile card-plain">
                  <CardBody>
                    <div className="card-avatar">
                      <a href="#pablo" onClick={(e) => e.preventDefault()}>
                        <img
                          alt="..."
                          src={
                            "https://svastha.in/wp-content/uploads/2021/05/1.png"
                          }
                        />
                        <CardTitle tag="h4">Tushar Pal</CardTitle>
                      </a>
                    </div>
                    <p className="card-description text-center">Tushar Pal</p>
                  </CardBody>
                  <CardFooter className="text-center">
                    <Button
                      className="btn-just-icon mr-1"
                      color="linkedin"
                      href="#pablo"
                      onClick={(e) => e.preventDefault()}
                    >
                      <i className="fa fa-linkedin" />
                    </Button>
                  </CardFooter>
                </Card>
              </Col>
            </Row>
            {/* Founder Section Ends */}
            {/* Tech Team Section Starts  */}
            <hr />
            <h2 className="text-center creators">Tech Team</h2>
            <Row>
              {techTeam.map((_data) => (
                <Col md="3">
                  <Card className="card-profile card-plain">
                    <CardBody>
                      <div className="card-avatar">
                        <a href="#pablo" onClick={(e) => e.preventDefault()}>
                          <img width={120} height={120} alt="..." src={_data.profilePicture} />
                          <CardTitle tag="h4">{_data.name}</CardTitle>
                        </a>
                      </div>
                      <p className="card-description text-center">
                        {_data.name}
                      </p>
                    </CardBody>
                    <CardFooter className="text-center">
                      <Button
                        className="btn-just-icon mr-1"
                        color="linkedin"
                        href={_data.linkedin}
                      >
                        <i className="fa fa-linkedin" />
                      </Button>
                    </CardFooter>
                  </Card>
                </Col>
              ))}
            </Row>
            {/* Tech Team Section Ends  */}
            {/* Volunteers Section Starts */}
            <hr />
            <h2 className="text-center creators">Volunteers</h2>
            <Row>
              {VoluteerDetails.map((_data) => (
                <Col md="2">
                  <Card
                    className="card-profile card-plain"
                    style={{ maxHeight: "200px " }}
                  >
                    <CardBody>
                      <div className="card-avatar">
                        <a href="#pablo" onClick={(e) => e.preventDefault()}>
                          <img alt="..." src={_data.profilePicture} />
                          <CardTitle tag="h4">{_data.name}</CardTitle>
                        </a>
                      </div>
                      <p className="card-description text-center">
                        {_data.name}
                      </p>
                    </CardBody>
                    <CardFooter className="text-center">
                      <Button
                        className="btn-just-icon mr-1"
                        color="linkedin"
                        href={_data.linkedin}
                      >
                        <i className="fa fa-linkedin" />
                      </Button>
                    </CardFooter>
                  </Card>
                </Col>
              ))}
            </Row>
            {/* Volunteers Section Ends */}
          </Container>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default Aboutus;
